import React from "react"

import {isEmpty} from "lodash"
import PropTypes from "prop-types"
import {Icon, Loader} from "semantic-ui-react"

import {
    STATUS_PILL_BACKGROUND_COLORS,
    STATUS_PILL_COLORS,
    STATUS_PILL_ICONS,
    StatusPillVariants,
    StatusPillVariantsDefaultLabels,
} from "../../constants/statusPillVariants"

import "./statusPill.scss"

const StatusPill = ({variant, label}) => (
    <div
        className="status-new"
        style={{
            backgroundColor: STATUS_PILL_BACKGROUND_COLORS[variant],
            color: STATUS_PILL_COLORS[variant],
        }}
    >
        <div>
            {isEmpty(variant) ? <Loader active inline size="small" /> : <Icon name={STATUS_PILL_ICONS[variant]} />}
            {label ?? StatusPillVariantsDefaultLabels[variant]}
        </div>
    </div>
)

StatusPill.propTypes = {
    label: PropTypes.string,
    variant: PropTypes.oneOf(Object.values(StatusPillVariants)),
}

export default StatusPill
